import { Component, computed, effect, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BoostrapDropdownComponent } from '@shared/components/boostrap-dropdown/boostrap-dropdown.component';
import { DynamicField } from '@shared/components/dynamic-form/models/field';
import { DropdownOption } from '@shared/components/dynamic-form/models/field-base';
import { FieldDropdown } from '@shared/components/dynamic-form/models/field-dropdown';
import { FIELD_TYPE } from '@shared/constants/field-type.const';

@Component({
  selector: 'app-dropdown-field',
  imports: [BoostrapDropdownComponent, TranslateModule],
  templateUrl: './dropdown-field.component.html',
})
export class DropdownFieldComponent {
  form = input.required<FormGroup>();
  field = input.required<DynamicField>();

  items = computed(() => {
    return (this.field() as FieldDropdown).options ?? [];
  });

  get formControl() {
    return this.form().controls[this.field().key];
  }

  currentIndex = 0;

  constructor() {
    effect(() => {
      this.updateDropdownSelectedIndex();
    });
  }

  setValue(item): void {
    this.currentIndex = this.items().findIndex(i => i.codeId === item.codeId);

    this.formControl.setValue(item.value);
  }

  private updateDropdownSelectedIndex() {
    if (
      this.field().controlType === FIELD_TYPE.DROPDOWN &&
      this.formControl.value
    ) {
      const selectedIndex = this.items().findIndex(
        (i: DropdownOption) => i.codeId === this.formControl.value
      );
      this.currentIndex = selectedIndex === -1 ? 0 : selectedIndex;
    }
  }
}
